var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22046 1.55449L3.50101 0.574707L3.78156 1.55449C4.12232 2.7444 4.9873 3.67592 6.09222 4.0429L7.00202 4.34502L6.09222 4.64715C4.9873 5.01413 4.12232 5.94565 3.78156 7.13556L3.50101 8.11534L3.22046 7.13556C2.8797 5.94565 2.01471 5.01413 0.909795 4.64715L0 4.34502L0.909795 4.0429C2.01471 3.67592 2.8797 2.7444 3.22046 1.55449Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16705 5.83472L9.74818 3.80518L10.3293 5.83472C11.0352 8.29954 12.8269 10.2291 15.1157 10.9893L17.0003 11.6151L15.1157 12.241C12.8269 13.0011 11.0352 14.9307 10.3293 17.3955L9.74818 19.4251L9.16705 17.3955C8.46118 14.9307 6.66943 13.0011 4.38067 12.241L2.49609 11.6151L4.38067 10.9893C6.66943 10.2291 8.46118 8.29954 9.16705 5.83472Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai_icon.9be7097b36b8076c50e01c96102d9fa1.svg";
export { ForwardRef as ReactComponent };